const parallaxIllustrations = () => {
    gsap.registerPlugin(ScrollTrigger);
    // Vertical parallax effect
    gsap.utils.toArray('.js-prlx').forEach(prlxItem => {
        gsap.fromTo(prlxItem,
            {
                y: 150,
            },
            {
                scrollTrigger: {
                    trigger: prlxItem,
                    start: "top bottom",
                    end: "bottom 200px",
                    scrub: true, // Give positive integer as value to get more easing/smoothness (e.g. 2,3,4)
                    markers: false, // Set to true to add markers to UI to debug.
                },
                y: -50,
                ease: "none",
                duration: 2,
            }
        );
    });
}

document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.js-prlx')) {
        parallaxIllustrations();
    }
});

